import { useState } from "react";
import { motion } from "framer-motion";

interface QuestionProductsProps {
  onNext: () => void;
  onBack: () => void;
  onSelect: (value: string[]) => void;
  selected: string[];
}

const options = [
  { label: "Crèmes en serums", value: "creams", emoji: "🧴" },
  { label: "Supplementen (collageen, vitamines)", value: "supplements", emoji: "💊" },
  { label: "Gezichtsbehandelingen (facial, peeling)", value: "facials", emoji: "💆‍♀️" },
  { label: "Apparaten (LED, radiofrequentie)", value: "devices", emoji: "🔌" },
  { label: "Kliniekbehandelingen (botox, fillers)", value: "clinic", emoji: "💉" },
  { label: "Niets specifiek geprobeerd", value: "nothing", emoji: "🤷‍♀️" },
];

const QuestionProducts = ({ onNext, onBack, onSelect, selected }: QuestionProductsProps) => {
  const toggleOption = (value: string) => {
    if (value === "nothing") {
      onSelect(["nothing"]);
      return;
    }
    const filtered = selected.filter((s) => s !== "nothing");
    if (filtered.includes(value)) {
      onSelect(filtered.filter((s) => s !== value));
    } else {
      onSelect([...filtered, value]);
    }
  };

  const hasSelection = selected.length > 0;

  return (
    <div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
      >
        <span className="text-xl">←</span> Terug
      </button>

      <div className="text-center">
        <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-2 leading-tight">
          Wat heb je al geprobeerd voor je huid?
        </h2>
        <p className="text-foreground/80 font-sans text-lg mb-6 md:mb-10">
          Selecteer alles dat van toepassing is en klik op volgende
        </p>

        <div className="grid gap-2 md:gap-3 mb-6 md:mb-8">
          {options.map((opt, i) => (
            <motion.button
              key={opt.value}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * i }}
              onClick={() => toggleOption(opt.value)}
              className={`quiz-option text-left flex items-center gap-4 ${
                selected.includes(opt.value) ? "quiz-option-selected" : ""
              }`}
            >
              <span className="text-2xl flex-shrink-0 w-8 text-center">{opt.emoji}</span>
              <span className="text-foreground font-medium text-lg">{opt.label}</span>
              {selected.includes(opt.value) && (
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="inline-block ml-2 text-primary"
                >
                  ✓
                </motion.span>
              )}
            </motion.button>
          ))}
        </div>

        {hasSelection && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <button onClick={onNext} className="btn-cta">
              Volgende
            </button>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default QuestionProducts;
